import { render, staticRenderFns } from "./HomeKitDetails.vue?vue&type=template&id=3a560543&scoped=true&"
import script from "./HomeKitDetails.vue?vue&type=script&lang=js&"
export * from "./HomeKitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a560543",
  null
  
)

export default component.exports